<template>
  <div class="smart-water-screen">
    <BackGround ref="background" />
    <div class="screen-content">
        <Header @tab-change="handleTabChange" />
      <!-- Tabs -->
        <div class="content-screen">
            <Supply v-if="currentTab === 'supply'" />
            <WorkOrder v-if="currentTab === 'workorder'" />
            <Inspection v-if="currentTab === 'inspection'" />
            <Operation v-if="currentTab === 'operation'" />
            <Main v-if="currentTab === 'main'" />
            <MeterReading v-if="currentTab === 'meterreading'" />
            <Drawer v-if="currentTab === 'controller'" />
        </div>
    </div>
  </div>
  
</template>

<script>
import BackGround from './components/BackGround.vue'
import Header from './components/Header.vue'
import Supply from './components/Supply.vue'
import WorkOrder from './components/WorkOrder.vue'
import Inspection from './components/Inspection.vue'
import Operation from './components/Operation.vue'
import Main from './components/Main.vue'
import MeterReading from './components/MeterReading.vue'
import Drawer from './components/Drawer.vue'

export default {
  name: 'SmartWaterScreen',
  components: {
    BackGround,
    Header,
    Supply,
    WorkOrder,
    Inspection,
    Operation,
    Main,
    MeterReading,
    Drawer,
  },
  data() {
    return {
      currentTab: 'supply'
    }
  },
  computed: {
    // i18n：页签名称使用 computed 以响应语言切换
    tabNames() {
      return {
        supply: this.$t('供水分析'),
        workorder: this.$t('工单管理'),
        inspection: this.$t('巡检管理'),
        operation: this.$t('运营分析'),
        main: this.$t('DMA概览'),
        meterreading: this.$t('抄表管理'),
        controller: this.$t('工艺控制'),
      }
    },
    currentTabName() {
      return this.tabNames[this.currentTab] || ''
    }
  },
  methods: {
    handleTabChange(tabKey) {
      this.currentTab = tabKey
    },
    
    
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
.smart-water-screen {
  // width: calc(100vw - 16px);
  // height: calc(100vh - 16px);
  width: 100%;
  height: 100vh;
  // 禁止页面滚动及滚动条
  overflow: hidden;
  background: transparent;
}

.screen-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  pointer-events: none;
}

.screen-content > * {
  pointer-events: auto;
}

.content-screen {
    flex: 1;
    padding: 8px;
    height: calc(100% - 80px); /* Adjust based on header height */
}
::v-deep html, 
::v-deep body, 
::v-deep #canvas{
  overflow-y: hidden;
}
</style>